import * as Accordion from '@bambi/component-library/src/components/Accordion/Accordion';
import { trim } from 'lodash-es';

import { TripCreateRead } from 'src/common/external/bambi-api/bambiApi';

import { TripSummaryCreateItemHeader } from './TripSummaryCreateItemHeader';
import { TripSummaryCreateParsedTrip } from './TripSummaryCreateParsedTrip';

export function TripSummaryCreateItem({
  onClick,
  tripEvent,
  // Used in Header
  isSelected,
}: {
  onClick: () => void;
  tripEvent: TripCreateRead;
  isSelected: boolean;
}) {
  return (
    <Accordion.Item value={String(tripEvent.id)} onClick={onClick}>
      <div
        className={`relative rounded-lg border border-solid border-[#eaecf0] hover:cursor-pointer`}
      >
        <style>
          {`
            [data-radix-collection-item][data-state="closed"] {
              background-color: #F9FAFB;
              border-bottom: 2px solid #EAECF0;
            }
            [data-radix-collection-item][data-state="open"] {
              background-color: rgba(38, 204, 198, 0.25);
              border-bottom: 2px solid #EAECF0;
            }
          `}
        </style>
        <Accordion.Trigger>
          <div
            className="w-full select-text"
            onClick={(e) => {
              // This must be combined with select-text css class
              //
              if (trim(window.getSelection()?.toString())) {
                e.stopPropagation();
              }
            }}
          >
            <TripSummaryCreateItemHeader tripEvent={tripEvent} />
          </div>
        </Accordion.Trigger>

        <Accordion.Content>
          <div
            className="p-2"
            onClick={(e) => {
              if (window.getSelection()?.toString()) {
                e.stopPropagation();
              }
            }}
          >
            {tripEvent.parsed_trip && (
              <TripSummaryCreateParsedTrip parsedTrip={tripEvent.parsed_trip} />
            )}
          </div>
        </Accordion.Content>
      </div>
    </Accordion.Item>
  );
}
